<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap>

      <v-flex md12>
        <app-table ref="staffTable" title="Staff" :config="config" @loaded="updateTableData"
          @filters="updateStaffFilters">

          <template slot="headerActions">
            <v-tooltip top>
              <template slot="activator" slot-scope="{ on }">
                <v-btn v-on="on" color="secondary" @click="signatureBulk()">
                  <v-icon>mdi-signature</v-icon>
                </v-btn>
              </template>
              <span>Gmail Signature Bulk</span>
            </v-tooltip>
          </template>

        </app-table>
      </v-flex>
    </v-layout>


    <v-dialog v-model="openBulkSignature" :max-width="600">

      <material-card title="Gmail Signature"
        :text="`Imposta i banner nella firma di Gmail per tutti (${totalStaffItems}) gli elementi selezionati`"
        color="primary">
        <v-form class="mt-4" ref="form" lazy-validation _v-model="validForm" autocomplete="off" role="presentation">
          <v-container grid-list-md>
            <slot name="prebody"></slot>
            <v-layout wrap>
              <core-field :key="templateField.value" :field="templateField" v-model="templateFieldValue" />
            </v-layout>
          </v-container>
        </v-form>

        <v-flex xs12 text-right>
          <b>ATTENZIONE!!!</b> Questi banner verranno associati a <b>{{ totalStaffItems }}</b> elementi
        </v-flex>

        <v-flex xs12 text-right>
          <v-btn class="mx-1 font-weight-light" color="success" @click="openBulkSignature = false">Close</v-btn>
          <v-btn class="mx-1 white--text" color="purple" :disabled="!templateFieldValue" :loading='savingBulkSignature'
            @click="saveBulkSignature()">
            Save
          </v-btn>
        </v-flex>
      </material-card>
    </v-dialog>

  </v-container>
</template>

<script>
import { post } from '@/api/base_entity.js'
import config from './config_index.js'


export default {
  data() {
    return {
      config,
      openBulkSignature: false,
      savingBulkSignature: false,
      templateFieldValue: null,
      staffFilters: {},
      totalStaffItems: [],
      templateField: {
        full: true,
        value: "press_banners",
        text: "Banner Firma Gmail",
        multiple: true,
        chips: true,
        items: [],
        deletable_chips: true,
        placeholder: '',
        loadRemote: true,
        type: "autocomplete",
        id: "id",
        subtitle: (item) => 'From ' + (item.dateFrom ?? '...') + ' to ' + (item.dateTo ?? '...'),
        reference: "press",
        default: () => undefined,
        filter: () => ({ 'press.type': `Banner Generator`, 'press.image': '!NULL' }),
        title: (item) => item.title
      },

    }
  },
  computed: {
  },
  methods: {
    mounted() {
      // if(this.$route.params.id) {

      // }

    },
    updateTableData(items, data) {
      this.totalStaffItems = data.tot;
    },
    updateStaffFilters(filters) {
      this.staffFilters = filters;
    },
    signatureBulk() {
      this.openBulkSignature = true
    },
    saveBulkSignature() {
      this.savingBulkSignature = true
      post(`staffBulkSignature`, { banners: this.templateFieldValue }, { 'x-filters': JSON.stringify(this.staffFilters) }).then(() => {
        this.savingBulkSignature = false
        this.openBulkSignature = false

        this.$root.$emit('openSnackbar', {
          message: 'Gmail signatures updated successfully',
          color: 'success'
        })

        this.$refs.staffTable.getData()


      }).catch(() => {
        this.savingBulkSignature = false
        this.$root.$emit('openSnackbar', {
          message: 'Error updating Gmail signatures',
          color: 'error'
        })
      })
    }
  }
}
</script>
